export const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours
export const CACHE_STALE_MS = 12 * 60 * 60 * 1000; // 12 hours
